import type { Telemetry } from '../core/types';

/** Subset of the New Relic Browser agent API we use. */
interface NewRelicApi {
  addPageAction(name: string, attributes?: Record<string, unknown>): void;
  noticeError(error: Error): void;
}

declare global {
  interface Window {
    newrelic?: NewRelicApi;
  }
}

/**
 * Bridge core game events to the page's telemetry backend.
 *
 * - When the New Relic Browser agent is present (`window.newrelic`, injected
 *   via the loader snippet in index.html once the POC NR app is configured),
 *   game events become NR PageActions — queryable with NRQL.
 * - Otherwise (dev, tests) events log to the console so they're still visible.
 *
 * Core stays vendor-free: it only knows the `Telemetry` interface.
 */
export function createTelemetry(): Telemetry {
  const nr = typeof window !== 'undefined' ? window.newrelic : undefined;
  if (nr) {
    return {
      gameEvent(name, payload) {
        nr.addPageAction(name, payload as Record<string, unknown>);
      },
    };
  }
  return {
    gameEvent(name, payload) {
      console.debug('[telemetry]', name, payload);
    },
  };
}
